export default __webpack_public_path__ + "static/media/FontAwesomeSolid.10ecefc2.ttf";